import FileManagerContainer from '../../../Componant/Application/FileManager/FileManager'

const FileManager = () => {
  return (
    <div className='page-body'>
      <FileManagerContainer />
    </div>
  )
}

export default FileManager